<template>
  <div class="catalogue-content">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .catalogue-content {
    place-content: center;
    container-type: inline-size;
    margin: 180px auto;
    padding: 0 24px;

    @include vgs-media-mobile-and-tablet {
      margin: 64px 0;
    }
  }
</style>
